var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 22H9C8.45 22 8 21.55 8 21V9C8 8.45 8.45 8 9 8H14C14.55 8 15 7.55 15 7C15 6.45 14.55 6 14 6H8C6.89 6 6 6.9 6 8V22C6 23.1 6.9 24 8 24H22C23.1 24 24 23.1 24 22V16C24 15.45 23.55 15 23 15C22.45 15 22 15.45 22 16V21C22 21.55 21.55 22 21 22ZM17 7C17 7.55 17.45 8 18 8H20.59L11.46 17.13C11.07 17.52 11.07 18.15 11.46 18.54C11.85 18.93 12.48 18.93 12.87 18.54L22 9.41V12C22 12.55 22.45 13 23 13C23.55 13 24 12.55 24 12V6H18C17.45 6 17 6.45 17 7Z",
    fill: "#9DA8BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.678223f5bc1db2ec9c6a59a3b104b427.svg";
export { ForwardRef as ReactComponent };